// `Select` + `SegmentedControl` (design-system spec §3.10). Select is the one
// filter control (27 px native select, styled); SegmentedControl is the small
// exclusive switch (view ranges — Today / Week / Month).

import type { ReactNode, SelectHTMLAttributes } from "react";

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  children: ReactNode;
}

export function Select({ children, className, ...rest }: SelectProps) {
  const classes = ["ds-select"];
  if (className !== undefined) classes.push(className);
  return (
    <select className={classes.join(" ")} {...rest}>
      {children}
    </select>
  );
}

export interface SegmentedOption<V extends string> {
  value: V;
  label: string;
}

export interface SegmentedControlProps<V extends string> {
  options: readonly SegmentedOption<V>[];
  value: V;
  onChange: (value: V) => void;
  /** Accessible name for the group. */
  label: string;
  "data-testid"?: string;
}

export function SegmentedControl<V extends string>({
  options,
  value,
  onChange,
  label,
  ...rest
}: SegmentedControlProps<V>) {
  return (
    <div className="ds-seg" role="group" aria-label={label} {...rest}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          aria-pressed={opt.value === value}
          onClick={() => {
            if (opt.value !== value) onChange(opt.value);
          }}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
